/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from "react";
import { Select, Button, Form, Row, Col, DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "dayjs/locale/es";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import { formatDate, removeDuplicates } from "../../utils/utils";
import { useSearchParams } from "react-router-dom";
import { useFetchOrdersBy, useFilters } from "../../app/orders/mutations";
import useFetchMaster from "../../app/maestro/mutations";
dayjs.extend(calendar);
const { RangePicker } = DatePicker;

export function HeaderForm({ onSubmit, disabled, ordersIds, documentsIds, isLoading}) {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDisabled, setIsDisabled] = useState(disabled);

  const [points, setPoints] = useState([]);

  const queryParams = Object.fromEntries([...searchParams]);
  let { isLoading: isLoadingMaster, data: master } = useFetchMaster();

  const { addFilter } = useFilters();

  useEffect(() => {
    setIsDisabled(disabled);
  }, [disabled]);

  const onFinish = (values) => {
    const { fechaInicioPedido: f1 } = values;

    if (f1 && f1.length === 2) {
      const [start, end] = f1;
      if (end.diff(start, 'days', true) > 10) {
        form.setFields([{
          name: 'fechaInicioPedido',
          errors: ['El rango de fechas no puede ser mayor a 10 dias'],
        }]);
        return;
      }
    }
    
    const queryDates = {
      fechaInicioPedido: formatDate(f1[0].$d),
      fechaFinPedido: formatDate(f1[1].$d),
    };

    setSearchParams(queryDates);
    onSubmit(queryDates);
    
    form.setFieldValue("cedula", null);
    form.setFieldValue("fechaFinPromesa", null);
    form.setFieldValue("fechaInicioPromesa", null);
  };

  const handleClientNameChange = (event) => {
    const client = event.split("-");
    addFilter({ label: "Cliente", prop: "nombreCliente", value: client[1] });
    useFetchOrdersBy();

    const points = master.clientes.filter((c) => c.id_cliente === client[0]);
    setPoints(points);
    form.setFieldValue("nombreCliente", null);
  };

  const handlePointChange = (event) => {
    addFilter({ label: "Punto de venta", prop: "puntoVenta", value: event });
    useFetchOrdersBy();
    form.setFieldValue("puntoVenta", null);
  };

  const handleDocumentChange = (event) => {
    const searchTerm = event;
    if (searchTerm) {
      addFilter({
        label: "Cedula",
        prop: "cedula",
        value: searchTerm,
      });
      useFetchOrdersBy();
    }
    form.setFieldValue("cedula", null);
  };

  const handleOrderChange = (event) => {
    const searchTerm = event;
    if (searchTerm && searchTerm.length > 0) {
      addFilter({ label: "Orden", prop: "ordenCompra", value: searchTerm });
      useFetchOrdersBy();
    }
    form.setFieldValue("ordenCompra", null);
  };

  const handleInitPromiseDate = (event) => {
    if (event) {
      const fecha = formatDate(event[1].$d);
      addFilter({
        label: "F. Inicial Promesa",
        prop: "fechaPromesa",
        value: fecha,
      });
      useFetchOrdersBy();
      form.setFieldValue("fechaFinPromesa", dayjs(formatDate(new Date())));
    }
  };

  const handleEndPromiseDate = (event) => {
    if (event) {
      const fecha = formatDate(event.$d);
      addFilter({
        label: "F. Fin Promesa",
        prop: "fechaFinPromesa",
        value: fecha,
      });
      useFetchOrdersBy();
    }
  };

  const handleClear = () => {
    form.setFieldValue("nombreCliente", undefined);
  };

  /*Control 30 dias en seleccion de fecha*/
  const [range, setRange] = useState([null, null]);

  const handleRangeChange = (dates) => {
    if (!dates || dates.length === 0) {
      setRange([null, null]);
      form.setFieldsValue({ fechaInicioPedido: null });
    } else {
      const [start, end] = dates;
      if (start && end && end.diff(start, 'days') > 10) {
        const newEnd = start.clone().add(10, 'days');
        setRange([start, newEnd]);
        form.setFieldsValue({ fechaInicioPedido: [start, newEnd] });
      } else {
        setRange(dates);
        form.setFieldsValue({ fechaInicioPedido: dates });
      }
    }
  };

  const disabledDate = (current) => {
    if (!range[0] && !range[1]) {
      return false;
    }
    const tooLate = range[0] && current > dayjs(range[0]).add(10, 'day');
    const tooEarly = range[1] && current < dayjs(range[1]).subtract(10, 'day');
    return tooLate || tooEarly;
  };
  /*Control 30 dias en seleccion de fecha*/

  return (
    <div className="orders-form">
      <Form
        form={form}
        autoComplete="off"
        name="ordersForm"
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          fechaInicioPedido: [dayjs(
            queryParams.fechaInicioPedido || dayjs().subtract(2, "day"),
            "YYYY-MM-DD"
          ),dayjs(
            queryParams.fechaFinPedido || dayjs().add(2, "day"),
            "YYYY-MM-DD"
          ),]
        }}
      >
        <Row className="form--first-row">
          <Col className="gutter-row">
            <Form.Item
              name="fechaInicioPedido"
              label="Fecha Pedido"
              rules={[{ required: true, message: "Requerido" }]}
            >
             <RangePicker
                locale={locale}
                size="medium"
                onCalendarChange={handleRangeChange}
                disabledDate={disabledDate}
                value={form.getFieldValue('fechaInicioPedido')}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item>
              <Button
                htmlType="submit"
                type="default"
                className="btn-green"
                id="btn-order"
                size="medium"
                disabled={isLoading}
                loading={isLoading}
              >
                Consultar
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
         
          <Col className="gutter-row">
            <Form.Item
              name="ordenCompra"
              rules={[{ required: false, message: "requerido" }]}
              label="Pedido / Orden"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={ordersIds.map((document) => {
                  return {
                    value: document,
                    label: document,
                  };
                })}
                onChange={handleOrderChange}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name="cedula"
              rules={[{ required: false, message: "requerido" }]}
              label="Cedula"
            >
              <Select
                showSearch
                size="medium"
                placeholder="Seleccione"
                disabled={isDisabled}
                onClear={handleClear}
                options={documentsIds.map((document) => {
                  return {
                    value: document,
                    label: document,
                  };
                })}
                onChange={handleDocumentChange}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            {!isLoadingMaster && master && (
              <Form.Item
                name="nombreCliente"
                rules={[{ required: false, message: "requerido" }]}
                label="Cliente"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  allowClear={true}
                  onClear={handleClear}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    ...removeDuplicates(
                      master?.clientes.map(
                        (e) => `${e.id_cliente}-${e.nombre_cliente}`
                      )
                    ).map((p, index) => {
                      return {
                        value: `${p}`,
                        label: `${p.toUpperCase().split("-")[1]}`,
                      };
                    }),
                  ]}
                  onChange={handleClientNameChange}
                />
              </Form.Item>
            )}
          </Col>

          <Col className="gutter-row">
            {!isLoadingMaster && master && (
              <Form.Item
                name="puntoVenta"
                rules={[{ required: false, message: "requerido" }]}
                label="Punto de venta"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    ...points.map((p) => {
                      return {
                        value: `${p.punto_venta}-${p.nombre_punto_venta}`,
                        label: `${p.punto_venta}-${p.nombre_punto_venta}`,
                      };
                    }),
                  ]}
                  onChange={handlePointChange}
                />
              </Form.Item>
            )}
          </Col>
          <Col className="gutter-row">
          <Form.Item
              name="fechaInicioPromesa"
              rules={[{ required: false, message: "Requerido" }]}
              label="Fecha Promesa"
            >
              <RangePicker
                locale={locale}
                size="medium"
                disabled={isDisabled}
                onChange={handleInitPromiseDate}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}